const KETCH_CONSENT_MANAGER_PLUGIN = 'KetchConsentManagerPlugin';
const KETCH_CONSENT_COOKIE_NAME_V1 = '_ketch_consent_v1_';

export { KETCH_CONSENT_MANAGER_PLUGIN, KETCH_CONSENT_COOKIE_NAME_V1 };
